import {Injectable, signal} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Params} from '@angular/router';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {MessageService} from '@lib-services/message.service';
import {IItem, IItemTableData} from '@lib-typing/item.interface';
import {ItemService} from '@lib-services/items.service';
import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {IPaginatedResponse} from '@lib-typing/response.interface';

@Injectable({
    providedIn: 'root',
})
export class ItemTableService implements ICommonTableService<IItemTableData> {
    public tableData$: BehaviorSubject<CommonTableData<IItemTableData>> = new BehaviorSubject<CommonTableData<IItemTableData>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private itemService: ItemService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.itemService
            .getItems(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(this.transformData(response)));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    case 'name':
                        filterValue = `$ilike:${value}`;
                        break;
                    case 'description':
                        filterValue = `$ilike:${value}`;
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

    transformData(response: IPaginatedResponse<IItem>): IPaginatedResponse<IItemTableData> {
        const transformedData = response.data.map(project => {
            return {
                id: project.id,
                createdAt: project.createdAt,
                updatedAt: project.updatedAt,
                orders: project.orders,
                name: project.name,
                category: project.category,
                description: project.description,
                categoryName: project.category?.name,
            } as IItemTableData;

        });
        // Return a new response object with transformed data
        return {
            ...response,
            data: transformedData
        };
    }
}
